<script lang="ts">
  export let size = 'normal';
  export let css = '';
</script>

<p class="paragraph {size}" style="{css};">
  <slot />
</p>

<style>
  p {
    color: var(--vlt-lp-background-text, #0e0f11);
    font-family: var(--vlt-lp-paragraph-font, 'DM Sans');
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    max-width: 100%;
    word-break: break-word;
  }
  p.normal {
    font-size: 16px;
    line-height: 28px;
  }
  p.small {
    font-size: 14px;
    line-height: 26px;
  }
  :global(.paragraph p) {
    margin-bottom: 10px;
  }
</style>
